import {observer} from "mobx-react";
import {fmsDocumentPrinterStore, FmsModalDialogPrintStore} from "../../../store";
import {FieldAutoComplete, ModalDialog} from "../../ui";
import {DialogAction} from "@kroschke/react-ui";

interface FmsModalDialogPrintDocumentProps {
    store: FmsModalDialogPrintStore,
    action: (printerId: string) => Promise<void>
}

const FmsModalDialogPrintDocument = observer(function FmsModalDialogPrintDocument({
    store,
    action
                                                                                }: FmsModalDialogPrintDocumentProps) {
    const actions: DialogAction[] = [
        {
            label: "Abbrechen",
            execute: async function () {
                store.dialogOpen = false
            },
            className: 'is-primary is-rounded is-small'
        },
    ]

    const documentPrinterId = store.documentPrinter?.id
    if (documentPrinterId) {
        actions.push({
            label: "Dokument drucken",
            execute: async function () {
                store.executing = true
                await action(documentPrinterId)
                store.executing = false
                store.dialogOpen = false
            },
            className: 'is-rounded is-small'
        })
    }


    return <ModalDialog
        store={store}
        actions={actions}
        title={"Dokument drucken"}
    >
        <div className={'columns'}>
            <div className={`column is-full`}>
                <FieldAutoComplete
                    label={"Dokumentendrucker"}
                    help={"Bitte wähle den zu verwendenden Drucker"}
                    required={true}
                    itemRenderer={c => c.label}
                    options={fmsDocumentPrinterStore.options}
                    search={async (v) => {
                        await fmsDocumentPrinterStore.find(v)
                        return fmsDocumentPrinterStore.options
                    }}
                    value={store.documentPrinter}
                    onChange={v => {
                        store.documentPrinter = v
                    }}
                />
            </div>
        </div>
    </ModalDialog>
})

export {
    FmsModalDialogPrintDocument
}
